export { default as Sakums } from './Sakums';
export { default as Kategorija } from './Kategorija';
export { default as Apakskategorija } from './Apakskategorija';
export { default as Raksts, RakstsJaunumi } from './Raksts';
export { default as Rezultati } from './Rezultati';
export { default as Dokumenti } from './Dokumenti';
export { default as Kontakti } from './Kontakti';
export { default as PasvaldibasKontakti } from './PasvaldibasKontakti';
export { default as KontaktiRezultati } from './KontaktiRezultati';
export { default as Deputati } from './Deputati';
export { default as Sitemap } from './Sitemap';
export { default as Pakalpojumi } from './Pakalpojumi';
export { default as Kluda } from './Kluda';
export { default as Mekletajs } from './Mekletajs';



// WEBPACK FOOTER //
// ./src/pages/index.js